import script from "./prePrint.vue?vue&type=script&setup=true&lang=js"
export * from "./prePrint.vue?vue&type=script&setup=true&lang=js"

import "./prePrint.vue?vue&type=style&index=0&id=1ce9b9d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ce9b9d6"]])

export default __exports__